import { CancelToken } from 'axios'
import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

export const deleteImageOutputService = (
  reportId: string,
  inputId: string,
  outputId: string,
  cancelToken?: CancelToken,
) =>
  apiInstance.delete(
    ApiPathConfig.IMAGE_OUTPUT_BY_ID(reportId, inputId, outputId),
    {
      cancelToken,
    },
  )
